import {
  INTEGRATION_TYPES,
  type IntegrationDefinition,
  type IntegrationEndpointInfo,
} from '../types'

export const DEFAULT_FASTTRACK_CONFIG = {}

const FASTTRACK_ENDPOINTS: IntegrationEndpointInfo[] = [
  {
    name: 'Search Permits',
    method: 'GET',
    description: 'Search for permits based on address criteria',
    toolName: 'search_permits',
  },
  {
    name: 'Get Permit Details',
    method: 'GET',
    description: 'Retrieves detailed information for a specific permit',
    toolName: 'get_permit_details',
  },
  {
    name: 'Get Permit Information',
    method: 'GET',
    description: 'Retrieves additional information including applicant and property details',
    toolName: 'get_permit_info',
  },
  {
    name: 'Get Permit Reviews',
    method: 'GET',
    description: 'Retrieves review information for a specific permit',
    toolName: 'get_permit_reviews',
  },
  {
    name: 'Get Permit Holds',
    method: 'GET',
    description: 'Retrieves hold information for a specific permit',
    toolName: 'get_permit_holds',
  },
  {
    name: 'Get Permit Inspections',
    method: 'GET',
    description: 'Retrieves inspection information for a specific permit',
    toolName: 'get_permit_inspections',
  },
  {
    name: 'Get Staff Info',
    method: 'GET',
    description: 'Retrieves staff directory information for the organization',
    toolName: 'get_staff_info',
  },
]

export const fasttrackIntegration: IntegrationDefinition = {
  id: INTEGRATION_TYPES.FASTTRACK,
  title: 'FastTrack',
  defaultConnectionName: 'FastTrack',
  logo: 'https://polimorphic-static.s3.us-east-2.amazonaws.com/3p-logos/fasttrack-banner.jpg',
  icon: 'https://polimorphic-static.s3.us-east-2.amazonaws.com/3p-logos/fasttrack-banner.jpg',
  cardDescription: 'Connect to FastTrack to manage permits and licensing.',
  modalDescription: 'Connect to FastTrack to manage permits and licensing workflows.',
  formFields: [
    {
      name: 'host',
      label: 'Host',
      placeholder: 'e.g., your-org.fasttrack.com',
      helperText: 'The FastTrack API host for your organization (without https://)',
      required: true,
      type: 'text',
    },
    {
      name: 'apiKey',
      label: 'API Key',
      placeholder: 'Enter your FastTrack API key',
      helperText: 'Your API key is stored securely and encrypted',
      required: true,
      type: 'password',
    },
  ],
  apiConfig: {
    createEndpoint: '/integrations/generate-fasttrack-integration/',
    buildPayload: (formData, _config, organizationId, organizationIdentityId) => {
      // Strip any existing protocol and normalize the host
      const host = formData.host.replace(/^https?:\/\//, '').replace(/\/+$/, '')
      return {
        organization_identity_id: organizationIdentityId,
        api_key: formData.apiKey,
        base_url: `https://${host}`,
        connection_name: formData.connectionName || 'FastTrack',
      }
    },
    authTokenName: 'query_param',
    buildTestCredentials: (formData) => ({ base_url: formData.host, api_key: formData.apiKey }),
  },
  defaultConfig: { ...DEFAULT_FASTTRACK_CONFIG },
  endpoints: FASTTRACK_ENDPOINTS,
  hostValidation: { pattern: /^fasttrack\.[a-zA-Z0-9-]+\.net$/, example: 'fasttrack.your-org.net' },
}
